var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "#5C34CD",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 9a.75.75 0 0 1-.22.53l-4.5 4.5a.75.75 0 0 1-1.06-1.06L10.94 9 6.97 5.03a.75.75 0 0 1 1.06-1.06l4.5 4.5c.141.14.22.331.22.53",
    clipRule: "evenodd"
  })));
};
export default SvgNext;